<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-emergency-delete"
      title="Delete User"
      ok-only
      ok-title="Delete"
      @ok="deleteItem"
    >
      <b-card-text>
        <h5>Are You Sure You Want to Remove This Emergency</h5>
        If you want to remove this Emergency, click the button below.
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-emergency-edit"
      no-close-on-backdrop
      ok-only
      centered
      size="lg"
      :title="createMode ? 'Add Emergency' : 'Edit Emergency'"
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col md="6">
            <b-form-group label="Diagnosis" label-for="diagnosis">
              <b-form-textarea
                id="diagnosis"
                v-model="EditForm.diagnosis"
                placeholder="Diagnosis"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Investigation" label-for="investigation">
              <b-form-textarea
                id="investigation"
                v-model="EditForm.investigation"
                placeholder="Investigation"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Examination" label-for="examination">
              <b-form-textarea
                id="examination"
                v-model="EditForm.examination"
                placeholder="Examination"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Treatment" label-for="treatment">
              <b-form-textarea
                id="treatment"
                v-model="EditForm.treatment"
                placeholder="Treatment"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card>
      <!-- Search Patient Name -->
      <div>
        <!-- Search Button -->

        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>Emergencies Table</h2>
          <div>
            <b-button
              :disabled="data.length == 0"
              variant="warning"
              class="mx-2"
              @click="
                $router.push({
                  name: 'patient-emergency-info',
                  params: { id: patientCardId },
                })
              "
            >
              See Patient Energency Page
            </b-button>
            <b-button
              v-if="!isHistory"
              variant="primary"
              @click="show(EditForm, 'create')"
            >
              Create Emergency
            </b-button>
          </div>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->

              <!-- Dropdown -->
              <b-dropdown
                v-if="!isHistory"
                variant="link"
                toggle-class="p-0"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item @click="show(data.item)">
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">Edit</span>
                </b-dropdown-item>
                <b-dropdown-item @click="deleteModel(data.item)">
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">Delete</span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing 1 to 10 Emergencies</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getPatientEmergiencies()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormTextarea,
  BSpinner,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
const AutoComplete = () => import('@/components/common/AutoComplete.vue');

import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    AutoComplete,
    BFormTextarea,
  },
  props: ['patientCardId', 'isHistory'],

  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        patient_card_id: '',
        investigation: '',
        diagnosis: '',
        examination: '',
        treatment: '',
        _method: 'PUT',
      },
      createMode: false,
      errorForm: {
        patient_card_id: '',
        investigation: '',
        diagnosis: '',
        examination: '',
        treatment: '',
      },
      params: {
        form: {},
        path: '',
      },
      tableColumns: [
        {
          key: 'patient_card.patient.name',
          label: 'Patient Name',
          sortable: true,
        },
        { key: 'diagnosis', sortable: true },
        { key: 'investigation', sortable: true },
        { key: 'treatment', sortable: true },
        { key: 'Actions' },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
    };
  },
  mounted() {
    this.getPatientEmergiencies();
  },
  methods: {
    show(item, mode) {
      if (mode === 'create') {
        this.createMode = true;
        this.EditForm = {
          patient_card_id: this.patientCardId,
          investigation: '',
          diagnosis: '',
          examination: '',
          treatment: '',
          _method: 'POST',
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.patient_card_id = this.patientCardId;
        this.EditForm.investigation = item.investigation;
        this.EditForm.diagnosis = item.diagnosis;
        this.EditForm.examination = item.examination;
        this.EditForm.treatment = item.treatment;
        this.EditForm._method = 'PUT';
      }
      this.$bvModal.show('modal-emergency-edit');
    },

    async getPatientEmergiencies() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/emergency?filter[patient_card_id]=${this.patientCardId}&page=${this.page}&take=${this.take}&sort=-id&include=patientCard`;

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show('modal-emergency-delete');
    },
    deleteItem() {
      this.$store
        .dispatch('delete', `/emergency/${this.deleteForm.id}`)
        .then((response) => {
          this.getPatientEmergiencies();

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: 'deleted ' + this.deleteForm.first_name + ' successfully',
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'Error deleting ' + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = '';
        if (this.EditForm[item] == '' || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/emergency`),
          this.$store
            .dispatch('create', this.params)
            .then((response) => {
              this.getPatientEmergiencies();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'validation error',
                      variant: 'danger',
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/emergency/${this.EditForm.id}`),
          this.$store
            .dispatch('update', this.params)
            .then((response) => {
              this.getPatientEmergiencies();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'validation error',
                      variant: 'danger',
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
